import { useEffect } from 'react';
import {
    Stack,
    Box,
    TextField,
    Button,
    InputAdornment,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';

function TableSearch({ search, setSearch, newPage, handleAdd, theme, disabled = false }) {
    useEffect(() => {
        if (disabled || search === undefined) return;
        if (!search) return;

        const timer = setTimeout(() => {
            newPage();
        }, 3000);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, disabled]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !disabled) {
            newPage();
        }
    };

    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            spacing={1.5}
            sx={{ mb: 2 }}
        >
            <TextField
                label="Search"
                placeholder="Search records..."
                variant="outlined"
                size="small"
                value={search}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                sx={{
                    flex: 1,
                    maxWidth: { sm: 420 },
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        bgcolor: '#fff',
                    },
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                        </InputAdornment>
                    ),
                }}
            />

            <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }} />

            {handleAdd ? (
                <Button
                    variant="contained"
                    onClick={handleAdd}
                    theme={theme}
                    startIcon={<AddIcon />}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '10px',
                        px: 2,
                        py: 1,
                        alignSelf: { xs: 'stretch', sm: 'center' },
                    }}
                >
                    Add
                </Button>
            ) : null}
        </Stack>
    );
}

export default TableSearch;
